import React, { ReactNode } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

interface RawHeaderProps {
  $padding?: string;
  $width?: string;
  $margin?: string;
}

const RawHeader = styled.div<RawHeaderProps>`
  width: ${props => props.$width ?? '100%'};
  padding: ${props => props.$padding ?? '10px 60px'};
  background: #f0faff;
  border-top: 1px solid #8ed3ff;
  border-bottom: 1px solid #8ed3ff;

  font-size: 12px;
  text-transform: uppercase;
  margin: ${props => props.$margin ?? '30px 0'};
`;

const Emphasis = styled.div`
  color: inherit;
  font-size: 0.8rem;
  font-style: italic;
  text-transform: none;
  display: block;
  margin: -5px 0;
`;

/** @public — required for declaration emit */
export interface Props {
  title: string;
  emphasis?: ReactNode;
  padding?: string;
  margin?: string;
  width?: string;
}

const Header = ({ title, emphasis = null, padding = null, margin = null, width = null }: Props) => (
  <RawHeader $padding={padding} $margin={margin} $width={width}>
    <Text strong>{title}</Text>
    {emphasis && <Emphasis>{emphasis}</Emphasis>}
  </RawHeader>
);

export default Header;
